
export enum TripActivityTypeCd {
	END_LUNCH = 'EndLunch',
	ENTER_GATE = 'EnterGate',
	LEAVE_GATE = 'LeaveGate',
	OTHER_ACTIVITY_END = 'OtherActivityEnd',
	OTHER_ACTIVITY_START = 'OtherActivityStart',
	START_LUNCH = 'StartLunch'}

